<template>
  <div class="columnas-obligatorias">
    <h6 class="titulo-columnas mb-3">Columnas obligatorias</h6>
    <b-row>
      <b-col cols="6">
        <div class="columna-item">
          <div class="d-flex align-items-center mb-2">
            <img alt="clinica" width="20px" :src="require('@/assets/adminClinicas/clinica.svg')" class="mr-2 icono-negro">
            <span class="nombre-columna">Clínica (Nombre)</span>
          </div>
          <div class="d-flex align-items-center">
            <img alt="hora-apertura" width="20px" :src="require('@/assets/icons/clock.svg')" class="mr-2">
            <span class="nombre-columna">Hora de apertura (Ej: 09:00)</span>
          </div>
        </div>
      </b-col>
      <b-col cols="6">
        <div class="columna-item">
          <div class="d-flex align-items-center mb-2">
            <img alt="dia" width="20px" :src="require('@/assets/icons/calendar1.svg')" class="mr-2">
            <span class="nombre-columna">Día (Ej: Lunes)</span>
          </div>
          <div class="d-flex align-items-center">
            <img alt="hora-cierre" width="20px" :src="require('@/assets/icons/clock.svg')" class="mr-2">
            <span class="nombre-columna">Hora de cierre (Ej: 23:59)</span>
          </div>
        </div>
      </b-col>
    </b-row>
    <h6 class="titulo-columnas mb-3 mt-4">Días sin operación</h6>
    <p class="texto-instruccion mb-0">
      Para indicar que un día no tiene operación, registra <strong>00:00</strong> en apertura y <strong>00:00</strong> en cierre
    </p>
  </div>
</template>

<script>
export default {
  name: 'ColumnasObligatorias'
}
</script>

<style scoped>
.columnas-obligatorias {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1rem 1.5rem;
  border: 1px solid #e9ecef;
}

.titulo-columnas {
  color: #333;
  font-weight: 600;
  font-size: 14px;
}

.columna-item {
  display: flex;
  flex-direction: column;
}

.nombre-columna {
  color: #555;
  font-size: 13px;
}

.texto-instruccion {
  color: #666;
  font-size: 13px;
}

.icono-negro {
  filter: brightness(0) saturate(100%);
}
</style>